import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AddButton from "../../../components/AddButton";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";
import ModalDetail from "../../../components/DetailModal";
import SearchBar from "../../../components/SearchBar";
import PaginatedTable from "../../../components/PaginatedTable";

import {
  getAllTransportations,
  deleteTransportation,
} from "../../../services/transportationsServices";

const DataAngkutan = () => {
  const [transportations, setTransportations] = useState([]);
  const [rawTransportations, setRawTransportations] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);

  const [selectedTransportation, setSelectedTransportation] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const navigate = useNavigate();

  const columns = [
    { key: "vehicle_number", label: "No. Kendaraan" },
    { key: "supplier", label: "Supplier" },
    { key: "sub_agent", label: "Sub Agent" },
    { key: "full_name", label: "Nama Mitra" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAllTransportations();

        const display = data.map((item) => ({
          id: item.id,
          vehicle_number: item.vehicle_number || "-",
          supplier: item.supplier?.name || "-",
          sub_agent: item.sub_agent?.name || "-",
          full_name: item.user?.profiles?.full_name || "-",
        }));

        setTransportations(display);
        setRawTransportations(data);
      } catch (err) {
        console.error("Failed to fetch transportations:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const filtered = transportations.filter((item) => {
    if (!search) return true;
    return [
      item.vehicle_number,
      item.supplier,
      item.sub_agent,
      item.full_name,
    ].some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    );
  });

  const handleEdit = (index) => {
    const selected = filtered[index];
    const original = rawTransportations.find((t) => t.id === selected.id);
    localStorage.setItem("editTransportation", JSON.stringify(original));
    navigate("/verifikasi/data-angkutan/edit");
  };

  const handleDelete = async (index) => {
    const selected = filtered[index];
    if (!selected) return;

    try {
      await deleteTransportation(selected.id);

      setTransportations((prev) => prev.filter((t) => t.id !== selected.id));
      setRawTransportations((prev) => prev.filter((t) => t.id !== selected.id));
    } catch (err) {
      console.error("Gagal menghapus angkutan:", err);
      alert("Gagal menghapus angkutan.");
    }
  };

  const handleView = (index) => {
    const selected = filtered[index];
    if (!selected) return;

    const original = rawTransportations.find((t) => t.id === selected.id);

    if (original) {
      const detailData = {
        "No. Kendaraan": original.vehicle_number || "-",
        Supplier: original.supplier?.name || "-",
        "Sub Agent": original.sub_agent?.name || "-",
        "Nama User": original.user?.profiles?.full_name || "-",
      };

      setSelectedTransportation(detailData);
      setShowDetailModal(true);
    }
  };

  return (
    <div className="pt-10 pl-64">
      <h2 className="pl-6 mb-6 text-2xl font-semibold text-green-700">
        Data Angkutan
      </h2>
      <div className="p-6 mx-4 bg-white shadow rounded-xl">
        <div className="flex items-center justify-between mb-4">
          <AddButton
            onClick={() => navigate("/verifikasi/data-angkutan/add")}
            moduleName="TransportationData"
          />
          <SearchBar value={search} onChange={setSearch} />
        </div>

        {isLoading ? (
          <p className="py-8 text-center text-gray-500">
            Memuat data angkutan...
          </p>
        ) : (
          <PaginatedTable
            data={filtered}
            columns={columns}
            onEdit={handleEdit}
            onDelete={(index) => {
              setSelectedDeleteIndex(index);
              setIsConfirmOpen(true);
            }}
            onView={handleView}
            moduleName="TransportationData"
          />
        )}

        <ConfirmDialog
          isOpen={isConfirmOpen}
          onClose={() => setIsConfirmOpen(false)}
          onConfirm={() => {
            if (selectedDeleteIndex !== null) {
              handleDelete(selectedDeleteIndex);
            }
          }}
          title="Hapus Angkutan"
          message="Apakah Anda yakin ingin menghapus data ini?"
        />

        {showDetailModal && (
          <ModalDetail
            data={selectedTransportation}
            onClose={() => setShowDetailModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default DataAngkutan;
